module.exports = __webpack_public_path__ + "img/xswap.d887f2bc.png";